import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HideCongratulationMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type HideCongratulationMutationPage = { readonly __typename?: 'RootMutationType', readonly disableFlag: boolean };


export const HideCongratulationDocument = gql`
    mutation HideCongratulation {
  disableFlag(name: CONGRATULATION)
}
    `;
export type HideCongratulationMutationFn = Apollo.MutationFunction<HideCongratulationMutationPage, HideCongratulationMutationVariables>;

/**
 * __useHideCongratulationMutation__
 *
 * To run a mutation, you first call `useHideCongratulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideCongratulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideCongratulationMutation, { data, loading, error }] = useHideCongratulationMutation({
 *   variables: {
 *   },
 * });
 */
export function useHideCongratulationMutation(baseOptions?: Apollo.MutationHookOptions<HideCongratulationMutationPage, HideCongratulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideCongratulationMutationPage, HideCongratulationMutationVariables>(HideCongratulationDocument, options);
      }
export type HideCongratulationMutationHookResult = ReturnType<typeof useHideCongratulationMutation>;
export type HideCongratulationMutationResult = Apollo.MutationResult<HideCongratulationMutationPage>;
export type HideCongratulationMutationOptions = Apollo.BaseMutationOptions<HideCongratulationMutationPage, HideCongratulationMutationVariables>;